import { useMemo } from 'react'
import { Network } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { GeoRegistryTable } from './GeoRegistryTable'
import { GEO_STR as S, type GeoConfigRow } from './geoApi'

/**
 * A11.15 — Tor tugunlari. Admin boshqaradigan Tor exit-tugun ro'yxati; IP qayta
 * qo'shilsa "oxirgi faollik" yangilanadi. JONLI CRUD: `/admin/geo/tor-nodes`.
 */
export function TorNodesScreen() {
  const columns = useMemo<AdminColumn<GeoConfigRow>[]>(
    () => [
      {
        key: 'ip',
        header: S.ip,
        type: 'text',
        minWidth: 200,
        render: (r) => <span className="font-mono tabular text-primary">{String(r.ip ?? '')}</span>,
      },
      { key: 'last_seen', header: S.lastSeen, type: 'date', width: 160 },
    ],
    [],
  )

  return (
    <GeoRegistryTable
      screenId="A11.15"
      title={S.torTitle}
      description={S.torNote}
      addLabel={S.addTorNode}
      path="/admin/geo/tor-nodes"
      listKey="nodes"
      searchKeys={['ip']}
      fields={[{ name: 'ip', placeholder: S.ip, mono: true }]}
      columns={columns}
      icon={<Network size={28} strokeWidth={1.5} />}
    />
  )
}
